module.exports = __webpack_public_path__ + "media/images/client-3-d409a2ba06e022b3b748ae6af9e0aab2.png";